import * as actionType from "../actions/actionTypes";

const initState = {
  userProfileLoading: false,
  userProfile: null,
  error: null,
  //profile address
  userProfileAddressLoading: false,
  userProfileAddress: null,
  errorAddress: null,
};

const initGetUserProfile = (state, action) => {
  return {
    ...state,
    userProfile: action.userProfile,
  };
};

const successGetUserProfile = (state, action) => {
  return {
    ...state,
    userProfile: action.userProfile,
  };
};

const failGetUserProfile = (state, action) => {
  return {
    ...state,
    error: action.error,
  };
};
//profile addresss
const initGetUserProfileAddress = (state, action) => {
  return {
    ...state,
    userProfileAddressLoading: action.userProfileAddressLoading,
  };
};

const successGetUserProfileAddress = (state, action) => {
  return {
    ...state,
    userProfileAddress: action.userProfileAddress,
  };
};

const failGetUserProfileAddress = (state, action) => {
  return {
    ...state,
    errorAddress: action.errorAddress,
  };
};

const Reducer = (state = initState, action) => {
  switch (action.type) {
    case actionType.INIT_GET_USER_PROFILE:
      return initGetUserProfile(state, action);
    case actionType.SUCCESS_GET_USER_PROFILE:
      return successGetUserProfile(state, action);
    case actionType.FAIL_GET_USER_PROFILE:
      return failGetUserProfile(state, action);
    //Profile Address
    case actionType.INIT_GET_USER_PROFILE_ADDRESS:
      return initGetUserProfileAddress(state, action);
    case actionType.SUCCESS_GET_USER_PROFILE_ADDRESS:
      return successGetUserProfileAddress(state, action);
    case actionType.FAIL_GET_USER_PROFILE_ADDRESS:
      return failGetUserProfileAddress(state, action);
    default:
      return { ...state };
  }
};

export default Reducer;
